// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function HighlightSection__Jsx3(props) {
  let __children = props.children;
  let __background = props.background;
  let background = __background !== undefined ? __background : "Neutral";
  let children = __children !== undefined ? __children : null;
  let variantClass;
  switch (background) {
    case "Neutral" :
      variantClass = "bg-tan-old-lace text-zinc-600 border-zinc-300";
      break;
    case "Muted" :
      variantClass = "bg-zinc-50 text-zinc-600 border-zinc-300";
      break;
    case "Danger" :
      variantClass = "bg-tan-old-lace text-zinc-600 border-tan-error-500";
      break;
  }
  return JsxRuntime.jsx("section", {
    children: children,
    className: TailwindMerge.twMerge([
      variantClass,
      "font-normal text-base leading-tight rounded border p-4"
    ])
  });
}

let make = HighlightSection__Jsx3;

exports.make = make;
/* tailwind-merge Not a pure module */
